(() => {
  if (window.fpPdpSimplifyReady) return;
  window.fpPdpSimplifyReady = true;
  const init = () => {
    document.querySelectorAll('[data-fp-purchase-review]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      let data;
      try { data = JSON.parse(root.querySelector('[data-fp-review-data]')?.textContent || '{}'); } catch { return; }
      if (String(data.product_external_id) !== root.dataset.productId) return;
      // Only a complete, concise, published product review. Preserve original wording and attribution.
      const reviews = Array.isArray(data.reviews) ? data.reviews : [];
      const suitable = reviews.filter(review => typeof review.body === 'string' && review.body.trim().length >= 25 && review.body.trim().length <= 190);
      const review = suitable.find(r => /fabric|soft|fit|print|design|quality|comfortable|colour|color/i.test(r.body)) || suitable[0];
      if (!review) return;
      const quote = root.querySelector('.fp-review-quote');
      quote.querySelector('blockquote').textContent = `“${review.body.trim()}”`;
      const fromEtsy = /etsy/i.test(review.source || '') || review.transparency_badges?.includes('review_written_in_etsy');
      quote.querySelector('figcaption').textContent = [review.reviewer_name || 'Customer', `${review.rating}/5`, fromEtsy && 'Originally on Etsy'].filter(Boolean).join(' · ');
      quote.hidden = false;
    });
    const dialog = document.querySelector('[data-fp-reviews-dialog]');
    if (!dialog || dialog.dataset.ready) return;
    dialog.dataset.ready = 'true';
    let previous;
    let suspended = false;
    let reviewFocus;
    const open = (trigger) => {
      previous = trigger || document.activeElement;
      if (!dialog.open) dialog.showModal();
      document.body.classList.add('fp-reviews-open');
      dialog.querySelector('[data-fp-reviews-close]').focus();
    };
    document.addEventListener('click', event => {
      const link = event.target.closest('a[href="#product-reviews"]');
      if (!link) return;
      event.preventDefault();open(link);
    });
    dialog.querySelector('[data-fp-reviews-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => { document.body.classList.remove('fp-reviews-open'); if (!suspended) previous?.focus(); });
    // Judge.me places photo galleries and review forms directly on body. Suspend
    // the native top-layer dialog while those are open, then return to the list.
    const appModals = new MutationObserver(() => {
      const appModal = Array.from(document.querySelectorAll('body > .jdgm-modal, body > .jdgm-review-widget-modal')).find(el => el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
      if (appModal && dialog.open) {
        reviewFocus = document.activeElement;
        suspended = true;
        dialog.close();
      } else if (!appModal && suspended) {
        suspended = false;
        dialog.showModal();
        document.body.classList.add('fp-reviews-open');
        if (reviewFocus && dialog.contains(reviewFocus)) reviewFocus.focus();
      }
    });
    appModals.observe(document.body, {childList:true, subtree:true, attributes:true, attributeFilter:['class','style']});
    if (location.hash === '#product-reviews') open();
    window.addEventListener('hashchange', () => { if (location.hash === '#product-reviews') open(); });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
